import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "regenerate-the-narrative",
  courseId: "reports-from-audio",
  order: 8,
  title: "Regenerate",
  summary:
    "Regenerate rewrites the whole narrative from the transcript using your current preferences. Use it after you change preferences, fix speaker names, or correct the transcript.",
  learn: [
    "Regenerate a narrative from the Narrative dropdown",
    "Know which settings a regeneration picks up and which were fixed at upload",
    "Avoid losing manual edits",
  ],
  sceneId: "regenerate-the-narrative",
  tourId: "regenerate-the-narrative",
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Regeneration throws away the current narrative and drafts a new one from the same transcript. Use it when the inputs changed: you fixed speaker names, corrected the transcript, or changed a report preference and want the whole report to reflect it.",
    },
    {
      type: "steps",
      items: [
        "If you are changing style, update **Report Preferences** (perspective, time format, headings) first and click **Save Preferences**.",
        "Open the case.",
        "Click the dropdown on the **Narrative** tab and choose **Regenerate Narrative**.",
        "Read the \"Confirm Narrative Regeneration\" dialog, then click **Confirm**. Click **Cancel** to back out.",
      ],
    },
    {
      type: "paragraph",
      text: "The case shows the processing screen while it drafts. The old score and suggestions are archived and replaced. If your department uses the policy check or the footage check, regenerating re-runs them too, so expect fresh suggestions in those categories.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "Manual edits are lost",
      text: "The dialog says it plainly: regeneration replaces the entire narrative and discards manual edits. If you have edits worth keeping, copy them out first, or regenerate before you start editing.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What regeneration reads",
      text: "It uses your current Report Preferences, plus the template and call sign saved on the case when it was created. The **Report Template** and **Report Detail Level** are chosen in **Report Settings** at upload. To change them, start a new case from **Previous Uploads** with the same file and pick the new settings.",
    },
    {
      type: "paragraph",
      text: "\"Preferences in depth\" lists what each preference changes in the draft.",
    },
  ],
  related: ["report-preferences-in-depth", "transcription-and-speakers", "report-templates"],
};

export default lesson;
